import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import Group from 'components/utils/Group'
import Sheet from 'components/utils/Sheet'
import ModalContext from 'contexts/ModalContext'
import TextButton from 'LuxKit/Button/TextButton'
import LineGlobeAltIcon from 'LuxKit/Icons/line/LineGlobeAltIcon'
import LineStarIcon from 'LuxKit/Icons/line/LineStarIcon'
import StructureLabel from 'LuxKit/Label/StructureLabel'
import BodyTextBlock from 'LuxKit/TextBlocks/BodyTextBlock'
import { rem } from 'polished'
import React, { useContext } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import styled from 'styled-components'
import CharterBundleLearnMoreModal from './CharterBundleLearnMoreModal'
import LineCalendarCheckIcon from 'LuxKit/Icons/line/LineCalendarCheckIcon'
import LineClockWithTickIcon from 'LuxKit/Icons/line/LineClockWithTickIcon'
import LinePlaneDepartureIcon from 'LuxKit/Icons/line/LinePlaneDepartureIcon'

const LABEL_OFFSET = 12

const Root = styled.div`
  padding-top: ${rem(LABEL_OFFSET)};
`

const RelativeSheet = styled(Sheet)`
  position: relative;
`

const AbsoluteLabel = styled(StructureLabel)`
  position: absolute;
  top: ${rem(-LABEL_OFFSET)};
  left: -1px;
`

const MainContent = styled(VerticalSpacer)`
  flex: 1;
`

function CharterBundleUSPs() {
  const intl = useIntl()
  const showModal = useContext(ModalContext)

  const flightHighlightsLabel = intl.formatMessage({
    id: '9FKAzxq2oOj1rzolG4wT',
    defaultMessage: 'Flight highlights',
    description: 'Heading for charter bundle flight USPs section on offer page',
  })

  const learnMoreLabel = intl.formatMessage({
    id: 's2PIjzozz75t5W7CqhlW',
    defaultMessage: 'Learn more',
    description: 'Link text to open the charter bundle learn more modal',
  })

  const showLearnMoreModal = () => {
    showModal(<CharterBundleLearnMoreModal />)
  }

  return <Root>
    <RelativeSheet border="highlight-primary" padding="28 20 20 20" borderRadius="S">
      <AbsoluteLabel variant="promotion">{flightHighlightsLabel}</AbsoluteLabel>
      <Group direction="vertical" desktopDirection="horizontal" verticalAlign="end" horizontalAlign="start">
        <MainContent gap={4}>
          <BodyTextBlock variant="medium" startIcon={<LineGlobeAltIcon />}>
            <FormattedMessage
              id="zyv-CtawjvPJvr3XMM08"
              defaultMessage="<b>Australia’s only direct flights</b> for a seamless journey to the Maldives."
              description="USP highlighting Australia's exclusive direct flights to the Maldives"
              values={{ b: (chunks: React.ReactNode) => <b>{chunks}</b> }}
            />
          </BodyTextBlock>
          <BodyTextBlock variant="medium" startIcon={<LinePlaneDepartureIcon />}>
            <FormattedMessage
              id="Z1YSFWCwB65RF5y79BnJ"
              defaultMessage="<b>Save up to 20 hours in transit*</b> when you fly direct from Melbourne."
              description="USP highlighting time saved by flying direct from Melbourne to the Maldives"
              values={{ b: (chunks: React.ReactNode) => <b>{chunks}</b> }}
            />
          </BodyTextBlock>
          <BodyTextBlock variant="medium" startIcon={<LineCalendarCheckIcon />}>
            <FormattedMessage
              id="MBAkWfg1rDA5J99jw_oF"
              defaultMessage="<b>Free cancellation</b> within 7 days, and flexible date change options. Conditions apply"
              description="USP highlighting free cancellation policy for charter bundle flights"
              values={{ b: (chunks: React.ReactNode) => <b>{chunks}</b> }}
            />
          </BodyTextBlock>
          <BodyTextBlock variant="medium" startIcon={<LineClockWithTickIcon />}>
            <FormattedMessage
              id="AXYzqcEv84XxiQipU5aH"
              defaultMessage="<b>Early check-in & late checkout</b> give you extra time to enjoy the Maldives (select packages)."
              description="USP highlighting early check-in and late checkout for Maldives charter bundle"
              values={{ b: (chunks: React.ReactNode) => <b>{chunks}</b> }}
            />
          </BodyTextBlock>
          <BodyTextBlock variant="medium" startIcon={<LineStarIcon />}>
            <FormattedMessage
              id="gXYs_PcknyGIAXSye0am"
              defaultMessage="<b>Luxury Escapes private charter</b> aboard a full service A330-200 aircraft."
              description="USP highlighting the exclusive Luxury Escapes private charter aircraft"
              values={{ b: (chunks: React.ReactNode) => <b>{chunks}</b> }}
            />
          </BodyTextBlock>
        </MainContent>
        <CSSBreakpoint max="tablet">
          <TextButton kind="tertiary" horizontalOutdent="start" onClick={showLearnMoreModal}>{learnMoreLabel}</TextButton>
        </CSSBreakpoint>
        <CSSBreakpoint min="desktop">
          <TextButton kind="tertiary" onClick={showLearnMoreModal}>{learnMoreLabel}</TextButton>
        </CSSBreakpoint>
      </Group>
    </RelativeSheet>
  </Root>
}

export default CharterBundleUSPs
